import './styles/app.scss'

import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Route, Routes } from 'react-router-dom'

import ErrorBoundary from './components/error-handler/ErrorBoundary'
import InitLIFFScript from './components/liff/InitiLIFFScript'
import LineUIDPage from './pages/_dev/LineUIDPage'
import CampaignPage from './pages/CampaignPage'
import { AppointmentPage } from './pages/contact/AppointmentPage'
import ContactPage from './pages/contact/Contact'
import CompletedPage from './pages/kyc/Completed'
import ConfirmationCID from './pages/kyc/ConfirmationCID'
import TermsAndConditions from './pages/kyc/TermsAndConditions'
import VerificationOTP from './pages/kyc/VerificationOTP'
import ListReminders from './pages/optimus/ListReminders'
import OptimusContextProvider from './pages/optimus/OptimusContextProvider'
import ReminderForm from './pages/optimus/ReminderForm'
import ConfirmationCIDCrossSell from './pages/pdpa/ConfirmationCIDCrossSell'
import SubmittedFormCrossSell from './pages/pdpa/SubmittedFormCrossSell'
import ConfirmLastDigitsCID from './pages/promise-to-pay/ConfirmLastDigitsCID'
import PersonalInfo from './pages/promise-to-pay/PersonalInfo'
import SubmittedForm from './pages/promise-to-pay/SubmittedForm'
import { AppProvider } from './providers/store'

function useQuery() {
    const queryString = decodeURIComponent(window.location.search).replace('?liff.state=', '')
    return new URLSearchParams(queryString)
}

// NOTE: Change later
// related: /thunder-connect/customer/otp
function KYCPages() {
    const query = useQuery()
    const context = query.get('/kyc?context')

    console.log({ env: process.env?.LIFF_KYC_ID })
    return (
        <InitLIFFScript
            liffId={process.env.LIFF_KYC_ID || ''}
            redirectUri={`${window.location}/kyc?context=${context}`}
        >
            <Routes>
                <Route index element={<ConfirmationCID />} />
                <Route path="verification-otp" element={<VerificationOTP />} />
                <Route path="terms-and-conditions" element={<TermsAndConditions />} />
                <Route path="done" element={<CompletedPage />} />
            </Routes>
        </InitLIFFScript>
    )
}

function PromiseToPayPages() {
    return (
        <InitLIFFScript liffId={process.env.LIFF_PROMISE_TO_PAY_ID || ''}>
            <Routes>
                <Route index element={<ConfirmLastDigitsCID />} />
                <Route path="personal-info" element={<PersonalInfo />} />
                <Route path="done" element={<SubmittedForm />} />
            </Routes>
        </InitLIFFScript>
    )
}

function PDPAPages() {
    return (
        <InitLIFFScript liffId={process.env.LIFF_CROSS_SELL_ID || ''}>
            <Routes>
                <Route index element={<ConfirmationCIDCrossSell />} />
                <Route path="done" element={<SubmittedFormCrossSell />} />
            </Routes>
        </InitLIFFScript>
    )
}

function ContactPages() {
    return (
        <InitLIFFScript liffId={process.env.LIFF_CONTACT_FORM || ''}>
            <Routes>
                <Route index element={<ContactPage />} />
                <Route path="make-appointment" element={<AppointmentPage />} />
            </Routes>
        </InitLIFFScript>
    )
}

function CampaignPages() {
    return (
        <InitLIFFScript liffId={process.env.SHARING_CAMPAIGN || ''}>
            <Routes>
                <Route index element={<CampaignPage />} />
            </Routes>
        </InitLIFFScript>
    )
}

function OptimusPages() {
    return (
        <OptimusContextProvider>
            <InitLIFFScript liffId={process.env.LIFF_OPTIMUS_ID || ''}>
                <Routes>
                    <Route index element={<ListReminders />} />
                    <Route path="edit-reminder" element={<ReminderForm />} />
                </Routes>
            </InitLIFFScript>
        </OptimusContextProvider>
    )
}

const isDevelopment = process.env.NODE_ENV === 'development'

function App() {
    return (
        <BrowserRouter>
            <ErrorBoundary>
                <AppProvider>
                    <Routes>
                        <Route path="/kyc/*" element={<KYCPages />} />
                        <Route path="/promise-to-pay/*" element={<PromiseToPayPages />} />
                        <Route path="/pdpa/*" element={<PDPAPages />} />
                        {isDevelopment && <Route path="/_uuid" element={<LineUIDPage />} />}
                        <Route path="/campaign/*" element={<CampaignPages />} />
                        <Route path="/contact/*" element={<ContactPages />} />
                        <Route path="/optimus/*" element={<OptimusPages />} />

                        <Route
                            path="/contact-form-not-found"
                            element={
                                <div className="abcs-container min-h-screen">
                                    <div className="m-auto text-center">
                                        <figure className="py-4">
                                            <FontAwesomeIcon
                                                icon={faExclamationCircle}
                                                color="gray"
                                                size="4x"
                                            />
                                        </figure>
                                        <div className="text-lg leading-relaxed font-semibold">
                                            ท่านไม่ได้ส่งคำถามให้เจ้าหน้าที่ภายในเวลาที่กำหนด
                                            กรุณากดปุ่มปัญหา/สอบถาม และแจ้งปัญหาอีกครั้ง
                                        </div>
                                    </div>
                                </div>
                            }
                        />
                        <Route path="*" element={<div>404</div>} />
                    </Routes>
                </AppProvider>
            </ErrorBoundary>
        </BrowserRouter>
    )
}

createRoot(document.getElementById('app') as HTMLElement).render(<App />)
